import * as lodash from 'lodash';

import {subProcessType} from '@ispm-shared/modules/bpmn/diagram-element-terms';
import GraphicsFactory from 'diagram-js/lib/core/GraphicsFactory';
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {END_NODE_ID, endEvent} from '../../../../../../ispm-web/shared/modules/bpmn/index';

export class PathwayGraphicsFactory extends GraphicsFactory {

  constructor(private eventBus, private elementRegistry) {
    super(eventBus, elementRegistry);
  }


  create(type, element, parentIndex) {
    let upgradedElement = ModelingUtil.getElementBO(element);
    if (ModelingUtil.isConnection(element) && (ModelingUtil.getConnectionTarget(element).id === END_NODE_ID || ModelingUtil.getConnectionTarget(element).type === endEvent)) {
      return super.create(type, element, 0);
      return;
    }
    if (upgradedElement.markedToBeRendered === false) {
      return;
    }
    if (element.parent.type !== subProcessType) {
      return super.create(type, element, parentIndex);
    }
  }


  update(type, element, gfx) {
    let upgradedElement = ModelingUtil.getElementBO(element);
    if (ModelingUtil.isConnection(element) && (ModelingUtil.getConnectionTarget(element).id === END_NODE_ID || ModelingUtil.getConnectionTarget(element).type === endEvent)) {
      return;
    }
    if (upgradedElement.markedToBeRendered === false) {
      return;
    }
    if (element.parent.type !== subProcessType) {
      return super.update(type, element, gfx);
    }
  }


  updateContainments(elements) {
    let parents;
    const filteredElements = elements.filter(element => element.parent && element.parent.type !== subProcessType && this.elementRegistry.getGraphics(element));

    parents = lodash.reduce(filteredElements, (map, e) => {

      if (e.parent) {
        map[e.parent.id] = e.parent;
      }

      return map;
    }, {});

    // update all parents of changed and reorganized their children
    // in the correct order (as indicated in our model)
    lodash.forEach(parents, (parent) => {

      const children = parent.children;

      if (!children) {
        return;
      }

      const childGfx = super._getChildrenContainer(parent);

      lodash.forEach(children.slice().reverse(), (c => {

        const gfx = this.elementRegistry.getGraphics(c);
        if (gfx) {
          this.prependTo(gfx.parentNode, childGfx);
        }
      }));
    });
  }


  remove(element) {
    const gfx = this.elementRegistry.getGraphics(element);
    if (gfx) {
      super.remove(element);
    }
  }


  private prependTo(newNode, parentNode, siblingNode?) {
    parentNode.insertBefore(newNode, siblingNode || parentNode.firstChild);
  }

}
